/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Users_Is_Role_DefaultInputs */

const en_tables_users_is_role_default = /** @type {(inputs: Tables_Users_Is_Role_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Role Default`)
};

const de_tables_users_is_role_default = /** @type {(inputs: Tables_Users_Is_Role_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Role Standard`)
};

/**
* | output |
* | --- |
* | "Is Role Default" |
*
* @param {Tables_Users_Is_Role_DefaultInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_users_is_role_default = /** @type {((inputs?: Tables_Users_Is_Role_DefaultInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Users_Is_Role_DefaultInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_users_is_role_default(inputs)
	return de_tables_users_is_role_default(inputs)
});